import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import TextareaAutosize from 'react-textarea-autosize';
import {useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import WriteAboutThePhotoModal from "../Modal/WriteAboutThePhotoModal";
import AnswerDropDown from "../component/AnswerDropDown";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import {tokenizeSentence} from "../../../../utils/utils";
import GenericQuestionModal from "../Modal/GenericQuestionModal/GenricQuestionModal";


export default function WriteAboutPhoto({className, ...props}) {
    const {question, questionActions} = useQuestion()
    const [showModal, setShowModal] = useState(false)
    const {id} = useParams()
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: "",
        time: 0
    })
    const [response, setResponse] = useState({})

    // They seem to be attending an outdoor music concert while waving their hands in the air.


    function submitAnswer() {
        let minWords = 9;
        // to integer
        minWords = Math.floor(minWords)
        if (tokenizeSentence(form?.answer).length < minWords) {
            actions.setError({
                non_field_errors: [`Answer should be at least ${minWords} words`]
            })
            return
        }
        actions.post(URLS.genericQuestionView, (data) => {
            let totalTimeInSec = (Date.now() - data.time) / 1000
            // remove decimal points
            totalTimeInSec = Math.floor(totalTimeInSec)

            return {
                ...data,
                time: totalTimeInSec
            }
        }).then(response => {
            setResponse(response?.data)
            setShowModal(true)
            setFormData({
                time: 0
            })
        })

    }


    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [id])


    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader
                {...question}
                timeLimit={question?.timeLimit && question?.timeLimit + 5000}

                />
            <div className={" flex flex-col items-center md:flex-row p-2 py-8 justify-center gap-8"}>
                <GenericQuestionModal
                    result={response}
                    showModal={showModal} setShowModal={setShowModal}/>
                <div className={"flex flex-col lg:flex-row  w-full gap-8"}>
                    <img src={question?.imgUrl} alt={"question"} className={"w-96 h-[354px] rounded-md "}/>

                    <div className={"flex-1"}>
                        <TextareaAutosize
                            minRows={14}
                            placeholder="Write your answer here"
                            value={form?.answer}
                            onChange={(e) => {
                                if (form.time === 0) {
                                    form.time = Date.now()
                                }
                                setFormData({
                                    answer: e.target.value
                                })
                            }}

                            className="w-full text-2xl  max-h-[354px] rounded-lg border-[1.5px] text-black-2 dark:text-white border-b-graydark  py-2 px-2 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter "
                        ></TextareaAutosize>
                        <FormNoneFieldErrors errors={error?.answer || error?.non_field_errors || error?.time}/>
                    </div>
                </div>


            </div>

            <QuestionFooter className={"mx-4 my-2"}
                            loading={loading}
                            onClickSubmit={submitAnswer}

            />

            <AnswerDropDown
                className={" mt-4 "}
                allowEditing={true}
                headerTitle={"Show Answer"}
                justifications={question?.answerText}
            />
        </div>

    )
}
